import { Injectable } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class MetaService {
  constructor(
    private title: Title,
    private meta: Meta,
  ) {}

  setTitle(title: string): void {
    this.title.setTitle(title);
  }

  setTag(tag: string, value: string): void {
    if (tag.startsWith('og:')) {
      this.meta.removeTag(`name="${tag}"`);
      this.meta.updateTag({ property: tag, content: value }, `property="${tag}"`);
    } else {
      this.meta.removeTag(`property="${tag}"`);
      this.meta.updateTag({ name: tag, content: value }, `name="${tag}"`);
    }
  }
}
